import {
  ISearchTransformer,
  IStandardAPIResponse,
  ITransformerReading,
  IReadingStatus,
} from "../../vm";
import { httpClient, handleErrorResp } from "../UtilService";

export async function getTransformerReadings(
  obj: ISearchTransformer
): Promise<IStandardAPIResponse<Array<ITransformerReading>>> {
  try {
    let res = await httpClient<Array<ITransformerReading>>(
      `transformer-readings`,
      "GET",
      obj
    );
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}

export async function updateTransformerReadingStatus(
  obj: IReadingStatus
): Promise<IStandardAPIResponse<any>> {
  try {
    let res = await httpClient<any>(
      `transformer-readings/status`,
      "PATCH",
      obj
    );
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}

export async function updateTransformerReading(
  data: ITransformerReading
): Promise<IStandardAPIResponse<ITransformerReading>> {
  try {
    let res = await httpClient<ITransformerReading>(
      `transformer-readings/${data._id}`,
      "PATCH",
      data
    );
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}
